import Base from '../../vcom/Base';
import VcomProvider from '../../VcomProvider';
import VcomSection from '../../vcom/const/VcomSection';
import EventService from '../../common/event/EventService';

async function getSystems() {
  const systemLevelSections = [
    VcomSection.COCKPIT,
    VcomSection.DASHBOARD,
    VcomSection.DOCUMENTS,
    VcomSection.EVALUATION,
    VcomSection.MONITORING,
    VcomSection.VIIU,
    VcomSection.PPC,
  ];
  if (systemLevelSections.includes(VcomProvider.section)) {
    return [{
      id: VcomProvider.systemId,
      label: VcomProvider.systemName,
    }];
  }
  const unsortedSystems = await Base.getSystems();
  const systems = Base.sortSystems(unsortedSystems);
  return Object.values(systems).map((system) => ({
    id: system.id,
    label: system.label,
  }));
}

function openTicketCreateModal(systems, multiple = true, closeOnSelect = false, subsequentlyOpenTicketPortletAfterTicketCreation = true) {
  EventService.dispatch('openTicketCreateModal', {
    data: {
      systems, subsequentlyOpenTicketPortletAfterTicketCreation, closeOnSelect, multiple,
    },
  });
}

const TicketCreateService = {
  getSystems,
  openTicketCreateModal,
};

export default TicketCreateService;
